import "./sw-toc.module.css";
import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { LANGUAGE, DATE, isApple } from "../../global.ts";
import Strings from "../../../models/Strings.json";
import Bedok from "../../../models/Bedok.json";

const BUDDHA = new URL("../../../public/buddha.png", import.meta.url).href;

function getCommentaries(language, book, isColor) {
    const parts = Bedok[language]["commentaries"];
    if (0 < book && book <= parts[0]) {
        return isColor
            ? Strings.baskets["colors"][0]
            : Strings.baskets2[LANGUAGE][0];
    } else if (parts[0] < book && book <= parts[1]) {
        return isColor
            ? Strings.baskets["colors"][1]
            : Strings.baskets2[LANGUAGE][1];
    } else {
        return isColor
            ? Strings.baskets["colors"][2]
            : Strings.baskets2[LANGUAGE][2];
    }
}

export default (user) => html`
    <div
        id="sw-toc"
        class="fixed top-0 right-0 z-50 max-h-screen w-80 md:w-100 lg:w-120 p-4 overflow-y-auto transition-transform translate-x-full bg-white dark:bg-gray-800"
        tabindex="-1"
        aria-labelledby="sw-toc-label">
        <a
            target="_blank"
            href="https://siliconwat.dev"
            data-drawer-hide2="sw-toc"
            href2="#heartbank"
            onclick="heartbank.alertAdmin('toc/click/title')"
            id="sw-toc-label"
            class="moul self-center text-2xl font-semibold whitespace-nowrap text-theme">
            <img
                src="${BUDDHA}"
                width="50"
                height="50"
                class="inline rounded-full" />
            <span class="ml-3">${unsafeHTML(Strings.toc[LANGUAGE])}</span>
        </a>
        <button
            title="${Strings.close[LANGUAGE]}"
            type="button"
            data-drawer-hide="sw-toc"
            aria-controls="sw-toc"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">${Strings.close[LANGUAGE]}</span>
        </button>
        <div
            class="h-full py-4 mt-3 font-medium text-xs md:text-sm overflow-y-auto overflow-x-hidden flex flex-col items-left justify-between">
            <form>
                <div
                    class="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                    <div
                        class="px-4 py-2 bg-white rounded-t-lg dark:bg-gray-800">
                        <label for="sw-toc-prompt" class="sr-only"
                            >Prompt</label
                        >
                        <textarea
                            id="sw-toc-prompt"
                            rows="4"
                            class="battambang w-full px-0 text-base placeholder:text-gray-300 text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400"
                            placeholder="${Strings.ama[LANGUAGE]}"
                            required></textarea>
                    </div>
                    <div
                        class="flex items-center justify-between px-3 py-2 border-t dark:border-gray-600 border-gray-200">
                        <button
                            id="sw-toc-submit"
                            type="button"
                            class="inline-flex items-center py-1 px-4 text-base font-medium text-center text-white bg-orange-500 rounded-lg focus:ring-4 focus:ring-orange-200 dark:focus:ring-orange-900 hover:bg-orange-800">
                            ${unsafeHTML(Strings.gemini[LANGUAGE])}
                        </button>
                        <div
                            class="flex ps-0 space-x-1 rtl:space-x-reverse sm:ps-2">
                            <button
                                id="sw-toc-global"
                                title="${Strings.select4[LANGUAGE]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 512 512">
                                    <path
                                        d="M50 284.8c4.2 2.1 9 3.2 14 3.2l50.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4l18.7 0c17.7 0 32-14.3 32-32l0-40c0-13.3 10.7-24 24-24s24-10.7 24-24l0-42.7c0-8.5 3.4-16.6 9.4-22.6l13.3-13.3c6-6 9.4-14.1 9.4-22.6L304 57c0-1.2-.1-2.3-.2-3.5-15.4-3.6-31.4-5.5-47.8-5.5-114.9 0-208 93.1-208 208 0 9.8 .7 19.4 2 28.8zm403.3 37.3c-3.2-1.4-6.7-2.1-10.5-2.1L432 320c-8.8 0-16-7.2-16-16s-7.2-16-16-16l-34.7 0c-8.5 0-16.6 3.4-22.6 9.4l-45.3 45.3c-6 6-9.4 14.1-9.4 22.6l0 18.7c0 17.7 14.3 32 32 32l18.7 0c8.5 0 16.6 3.4 22.6 9.4 2.2 2.2 4.7 4.1 7.3 5.5 39.3-25.4 69.5-63.6 84.6-108.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM128 368c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 256c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm48-112l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z" />
                                </svg>
                                <span class="sr-only">Global</span>
                            </button>
                            <button
                                id="sw-toc-copy"
                                title="${Strings.select4[LANGUAGE]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l58.5 58.5c3 3 4.7 7.1 4.7 11.3L400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-197.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-48 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0 0-48-16 0z" />
                                </svg>
                                <span class="sr-only">Copy</span>
                            </button>
                            <button
                                id="sw-toc-paste"
                                title="${Strings.select8[LANGUAGE]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 384 512">
                                    <path
                                        d="M232 96l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0 48c37.1 0 67.6-28 71.6-64L320 80c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l16.4 0c4 36 34.5 64 71.6 64l80 0zM291.9 32C279 12.7 257 0 232 0L152 0c-25 0-47 12.7-59.9 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-28.1 0z" />
                                </svg>
                                <span class="sr-only">Paste</span>
                            </button>
                            <button
                                id="sw-toc-clear"
                                title="${Strings.clear[LANGUAGE]}"
                                type="button"
                                class="inline-flex justify-center items-center p-2 text-gray-500 rounded-sm cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
                                <svg
                                    class="w-4 h-4"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 448 512">
                                    <path
                                        d="M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z" />
                                </svg>
                                <span class="sr-only">Clear</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <ul
                id="sw-toc-history"
                class="battambang text-sm text-gray-600 dark:text-gray-300 mt-4 mb-8 px-1 space-y-3"></ul>
            <hr class="border-gray-300 dark:border-gray-700" />
            <ul class="space-y-2 mt-7 tb-3">
                <li class="moul">
                    <button
                        id="sw-toc-commentaries-khmer-btn"
                        onclick="heartbank.alertAdmin('menu/click/${Strings
                            .commentariesKhmer[LANGUAGE]}')"
                        type="button"
                        class="flex items-center w-full p-2 text-base text-amber-700 transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                        aria-controls="sw-toc-commentaries-khmer"
                        data-collapse-toggle="sw-toc-commentaries-khmer">
                        <svg
                            class="shrink-0 w-5 h-5 text-amber-700 transition duration-75"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 448 512">
                            <path
                                d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                        </svg>
                        <span
                            class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                            >${Strings.commentariesKhmer[LANGUAGE]}</span
                        >
                        <svg
                            class="w-3 h-3 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 4 4 4-4" />
                        </svg>
                    </button>
                    <ul
                        id="sw-toc-commentaries-khmer"
                        class="hidden py-2 space-y-2">
                        ${Array(Bedok["khmer"].commentaries[2])
                            .fill(0)
                            .map(
                                (_, book) => html`
                                    <li>
                                        <div
                                            class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                            <a
                                                onclick="heartbank.alertAdmin('menu/click/${Strings
                                                    .commentariesKhmer[
                                                    LANGUAGE
                                                ]}/${book + 1}')"
                                                href="https://bedok.siliconwat.dev/tipitaka/cambodia/${encodeURIComponent(
                                                    "ព្រះត្រៃបិដក ប្រែរួមនឹងអដ្ឋកថា ភាគ" +
                                                        (book + 1).toKhmer(
                                                            "khmer"
                                                        )
                                                )}.pdf"
                                                target="_blank"
                                                class="${getCommentaries(
                                                    "khmer",
                                                    book + 1,
                                                    true
                                                )}">
                                                ${getCommentaries(
                                                    "khmer",
                                                    book + 1,
                                                    false
                                                )}
                                                <span
                                                    class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                    ${(book + 1).toKhmer(
                                                        LANGUAGE
                                                    )}
                                                </span>
                                            </a>
                                            <button
                                                class="ml-5"
                                                title="${Strings.download[
                                                    LANGUAGE
                                                ]}"
                                                onclick="heartbank.alertAdmin('menu/click/download/${Strings
                                                    .commentariesKhmer[
                                                    LANGUAGE
                                                ]}/${book +
                                                1}');alert('${Strings.soon[
                                                    LANGUAGE
                                                ]}')">
                                                <svg
                                                    class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 448 512">
                                                    <path
                                                        d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </li>
                                `
                            )}
                    </ul>
                </li>
                <li class="moul">
                    <button
                        id="sw-toc-commentaries-pali-btn"
                        onclick="heartbank.alertAdmin('menu/click/${Strings
                            .commentariesPali[LANGUAGE]}')"
                        type="button"
                        class="flex items-center w-full p-2 text-base text-amber-700 transition duration-75 rounded-lg group hover:bg-gray-100 dark:hover:bg-gray-700"
                        aria-controls="sw-toc-commentaries-pali"
                        data-collapse-toggle="sw-toc-commentaries-pali">
                        <svg
                            class="shrink-0 w-5 h-5 text-amber-700 transition duration-75"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 448 512">
                            <path
                                d="M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L384 0 96 0zm0 384l256 0 0 64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm16 48l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
                        </svg>
                        <span
                            class="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap"
                            >${Strings.commentariesPali[LANGUAGE]}</span
                        >
                        <svg
                            class="w-3 h-3 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 10 6">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 4 4 4-4" />
                        </svg>
                    </button>
                    <ul
                        id="sw-toc-commentaries-pali"
                        class="hidden py-2 space-y-2">
                        ${Array(Bedok["pali"].commentaries[2])
                            .fill(0)
                            .map(
                                (_, book) => html`
                                    <li>
                                        <div
                                            class="text-sm flex items-center w-full p-2 transition duration-75 rounded-lg pl-11 group hover:bg-gray-100 dark:hover:bg-gray-700">
                                            <a
                                                onclick="heartbank.alertAdmin('menu/click/${Strings
                                                    .commentariesPali[
                                                    LANGUAGE
                                                ]}/${book + 1}')"
                                                href="https://bedok.siliconwat.dev/commentaries/pali/${encodeURIComponent(
                                                    Bedok["pali"]
                                                        .commentariesBooks[book]
                                                )}.pdf"
                                                target="_blank"
                                                class="${getCommentaries(
                                                    "pali",
                                                    book + 1,
                                                    true
                                                )}">
                                                ${getCommentaries(
                                                    "pali",
                                                    book + 1,
                                                    false
                                                )}
                                                <span
                                                    class="ms-2 bg-blue-100 text-blue-800 me-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                                    ${(book + 1).toKhmer(
                                                        LANGUAGE
                                                    )}
                                                </span>
                                            </a>
                                            <button
                                                class="ml-5"
                                                title="${Strings.download[
                                                    LANGUAGE
                                                ]}"
                                                onclick="heartbank.alertAdmin('menu/click/download/${Strings
                                                    .commentariesPali[
                                                    LANGUAGE
                                                ]}/${book +
                                                1}');alert('${Strings.soon[
                                                    LANGUAGE
                                                ]}')">
                                                <svg
                                                    class="w-5 h-5 fill-gray-700 dark:fill-gray-400"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 448 512">
                                                    <path
                                                        d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </li>
                                `
                            )}
                    </ul>
                </li>
            </ul>
        </div>
    </div>
`;
